import { Col, Row } from "react-bootstrap";

export default function Benefits() {
  const benefits = [
    {
      title: "Property Searches",
      icon: "wired-outline-63-home-hover-3d-roll",
      description:
        "Unlimited preliminary municipal searches for properties across the NYC five boroughs.",
    },
    {
      title: "Expert Courses",
      icon: "wired-outline-406-study-graduation-hover-pinch",
      description:
        "Exclusive, expertly curated courses crafted to enhance and deepen your knowledge of Real Estate.",
    },
    {
      title: "Recurring Socials",
      icon: "wired-outline-2989-martini-glass-hover-cheers",
      description:
        "Recurring Socials designed to connect you with industry professionals and foster meaningful relationships.",
    },
    {
      title: "Valuable Resources",
      icon: "wired-outline-952-business-network-hover-pinch",
      description:
        "A network of resources to address your real estate challenges, complemented by exclusive discounts.",
    },
  ];
  return (
    <div className="benefits">
      <Row>
        {benefits.map((benefit, index) => (
          <Col key={index} md={6}>
            <div className="benefit-item">
              <div>
                <img
                  src={`/lordicon/bold/${benefit.icon}.gif`}
                  alt={benefit.title}
                />
              </div>
              <h2>{benefit.title}</h2>
              <div>{benefit.description}</div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}
